import BoxShadowContainer from "components/UIComponents/BoxShadowContainer";
import PaymentMethodComponent from "../PaymentMethodComponent";
import { paymentMethods } from "../paymentMethods";
import { useEffect, useState } from "react";
import { Divider, Heading, Text } from "@chakra-ui/react";

const PaymentMethodsContainer = ({ setCurrency, setNetwork }) => {
  const [methods, setMethods] = useState(paymentMethods);
  const [selectedMethod, setSelectedMethod] = useState(null);

  const handlePaymentMethodClick = (id) => {
    const updatedMethods = methods.map((method) => {
      if (method.id === id) {
        return { ...method, isSelected: !method.isSelected };
      } else {
        return { ...method, isSelected: false };
      }
    });

    const lastSelectedMethod = updatedMethods.filter(
      (method) => method.isSelected
    );
    setSelectedMethod({ ...lastSelectedMethod });
    setMethods(updatedMethods);
  };

  const anySelectedMethod = methods.some((method) => method.isSelected);

  useEffect(() => {
    if (selectedMethod && Object.keys(selectedMethod).length) {
      setCurrency(selectedMethod[0].abbr);
      setNetwork(selectedMethod[0].network);
    } else {
      setCurrency(null);
      setNetwork(null);
    }
  }, [selectedMethod, setCurrency, setNetwork]);

  return (
    <BoxShadowContainer className="payment-methods-block">
      <Heading size="lg" mb={5}>
        Select payment method
      </Heading>
      <div className="payment-methods-container">
        {methods.map((item) => (
          <PaymentMethodComponent
            handleOnClick={() => handlePaymentMethodClick(item.id)}
            key={item.id}
            {...item}
          />
        ))}
      </div>
      {anySelectedMethod && (
        <>
          <Divider mt={7} mb={7} />
          <Text textColor="text.secondary">Payment method</Text>
          <Text>{selectedMethod[0]?.name}</Text>
        </>
      )}
    </BoxShadowContainer>
  );
};

export default PaymentMethodsContainer;